import { useEffect } from "react";

import { useCommentsStore } from "../stores/commentStore";

export const useMouseHandle = () => {
  const { setIsInAddCommentMode, setOpenCommentId, setIsNewCommentOpen, isInAddCommentMode } =
    useCommentsStore();

  useEffect(() => {
    const handleRightClick = (event: MouseEvent) => {
      if (event.ctrlKey || !isInAddCommentMode) {
        return;
      }
      setOpenCommentId(undefined);
      setIsNewCommentOpen(false);
      setIsInAddCommentMode(false, { source: "mouse_click" });
    };

    window.addEventListener("contextmenu", handleRightClick);

    return () => {
      window.removeEventListener("contextmenu", handleRightClick);
    };
  }, [setIsInAddCommentMode, setOpenCommentId, setIsNewCommentOpen, isInAddCommentMode]);
};
